import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Strikethrough = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0272 8.47727H16.5727C16.5018 6.4875 14.6666 5 12.1166 5C9.59235 5 7.60902 6.46818 7.60902 8.68333C7.60902 9.60445 7.95496 10.3318 8.57511 10.9014H4V11.968H20V10.9014H12.0979L11.7045 10.7955C10.7257 10.5379 9.15447 10.0227 9.15447 8.60606C9.15447 7.34394 10.3136 6.41667 12.0651 6.41667C13.6621 6.41667 14.8727 7.17652 15.0272 8.47727ZM15.2075 14.7621C15.2075 13.8982 14.6728 13.3908 13.911 13.0347H16.2465C16.5575 13.4993 16.753 14.0738 16.753 14.7879C16.753 16.9258 15.0272 18.6 11.9878 18.6C9.15447 18.6 7.40296 17.1318 7.24841 14.9682H8.8969C9.02569 16.4621 10.4166 17.1576 11.9878 17.1576C13.8166 17.1576 15.2075 16.2045 15.2075 14.7621Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default Strikethrough
